type TokenType = {
  accessToken: string
  refreshToken: string
  expired: string
  tokenType: string
}

export const getTokenStorage = (name: string): string | null => {
  const data = sessionStorage.getItem('token')
  if (!data) {
    return null
  }
  const token = JSON.parse(data)
  return token.hasOwnProperty(name) ? token[name] : null
}

export const setTokenStorage = (value: TokenType): void => {
  const { accessToken, refreshToken } = value
  sessionStorage.setItem('token', JSON.stringify({ accessToken, refreshToken }))
}

type getVideoCodecType = () => 'H265_HLS' | 'H265_DASH' | 'VP9'

const codecH265 = 'application/vnd.apple.mpegurl; codecs="hvc1.1.6.L93.90"'
const codecDash = 'video/mp4; codecs="hev1.1.6.L93.90"'

export const getVideoCodec: getVideoCodecType = () => {
  // return 'VP9'

  const agent = window.navigator.userAgent.toLowerCase()
  if (agent.indexOf('edg') > 0 || agent.indexOf('edge') > 0 || agent.indexOf('android') > 0) {
    // return 'H265_DASH'
    return 'VP9'
  }

  let video: any = document.createElement('video')
  if (video.canPlayType(codecH265) === 'probably' || video.canPlayType(codecH265) === 'maybe') {
    video = null
    // Safari
    return 'H265_HLS'
  } else {
    video = null
    if (window.MediaSource && typeof window.MediaSource.isTypeSupported === 'function') {
      if (window.MediaSource.isTypeSupported(codecDash)) {
        return 'H265_DASH'
      }
    }
  }
  // return 'H265_DASH'
  return 'VP9'
}

export const getTouchPoints = (event: TouchEvent): { x: number; y: number }[] => {
  return Array.from(event.touches).map((touch) => ({ x: touch.clientX, y: touch.clientY }))
}

export const distanceBetween = (p1: { x: number; y: number }, p2: { x: number; y: number }): number => {
  return Math.sqrt(Math.pow(p2.x - p1.x, 2) + Math.pow(p2.y - p1.y, 2))
}
